import styled from "@emotion/styled";
import {
  Button,
  Col,
  Dropdown,
  MenuProps,
  message,
  Modal,

  Typography,
} from "antd";
import { FC } from "react";
import { bags, comments, hearts, stock } from "assets/icons";
import { GetProductListData } from "services/interface";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useDeleteProduct, useUpdateStatusProduct } from "hooks/useProduct";
import { useNavigate } from "react-router-dom";
import noImage from "assets/images/no-image.png";


interface ProductCardProps {
  data: GetProductListData | undefined;
  refetch: () => void;
  refetchTo?: () => void;
}

const { confirm } = Modal;

function removeHTMLTags(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

const ProductCard: FC<ProductCardProps> = ({ data, refetch, refetchTo }) => {
  const { mutate } = useDeleteProduct();
  const { mutate : updateStatus } = useUpdateStatusProduct();
  const navigate = useNavigate();

  const showDeleteConfirm = () => {
    if (!data?.id) return;
    confirm({
      title: "คุณต้องการลบสินค้าชิ้นนี้ใช่หรือไม่",
      icon: <ExclamationCircleFilled />,
      content: "คุณต้องการลบสินค้าชิ้นนี้ใช่หรือไม่",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        mutate(data?.id, {
          onSuccess: () => {
            message.success("ลบสินค้าสำเร็จ");
            refetch();
          },
          onError: () => {
            message.error("ลบสินค้าไม่สำเร็จ");
          },
        });
      },
      onCancel() {
        //console.log("Cancel");
      },
    });
  };

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: <div>ราคา/สต๊อก</div>,
    },
    // {
    //   key: "2",
    //   label: <div onClick={showDeleteConfirm}>ลบสินค้า</div>,
    // },
  ];

  return (
    <Col sm={24} md={12} xl={8} span={24}>
      <CardWrapper>
        <CardContentWrapper>
          <ImageWrapper>
            <img
              src={data?.image_url ?? noImage}
              width={"100%"}
              height={"100%"}
              alt="Product order"
              style={{ objectFit: "cover" }}
            />
          </ImageWrapper>
          <TextWrapper>
            <Typography.Text className="text-order-product-name">
              {data && data.name && data?.name.length  > 50
                ? data?.name.slice(0, 50) + "..."
                : data?.name}
            </Typography.Text>
            <Typography.Text className="text-order-product-name">
            {data && data.description && data?.description.length > 60
              ?  (removeHTMLTags(data?.description).slice(0, 60)) + "..."
              :  data?.description !== undefined ? removeHTMLTags(data?.description) : ''}
            </Typography.Text>
            <Typography.Text className="text-order-product-price">
              ราคา :{data?.sell_price_range}
            </Typography.Text>
          </TextWrapper>
        </CardContentWrapper>
        <Divider />
        <CardPriceWrapper>
          <RowStockAndOrder>
            <ColumnStock>
              <IconWrapper>
                <SpanIcon>{stock}</SpanIcon>
              </IconWrapper>
              <Typography.Text className="text-order-product-stock">
                สต๊อกทั้งหมด {data?.total_stock}
              </Typography.Text>
            </ColumnStock>
            <ColumnStock>
              <IconWrapper>
                <SpanIcon>{bags}</SpanIcon>
              </IconWrapper>
              <Typography.Text className="text-order-product-stock">
                ยอดขาย {data?.total_sold}
              </Typography.Text>
            </ColumnStock>
          </RowStockAndOrder>
          <RowStockAndOrder>
            <ColumnStock>
              <IconWrapper>
                <SpanIcon>{hearts}</SpanIcon>
              </IconWrapper>
              <Typography.Text className="text-order-product-stock">
                ถูกใจ {data?.total_favourite}
              </Typography.Text>
            </ColumnStock>
            <ColumnStock>
              <IconWrapper>
                <SpanIcon>{comments}</SpanIcon>
              </IconWrapper>
              <Typography.Text className="text-order-product-stock">
                ความคิดเห็น {data?.total_comment}
              </Typography.Text>
            </ColumnStock>
          </RowStockAndOrder>
        </CardPriceWrapper>
        <Divider />
        <DateWrapper>
          <Button
            onClick={() => {
              updateStatus(
                {
                  id: data?.id || '',
                  is_active: !data?.is_active,
                }, {
                onSuccess: (data) => {
                  if (data.status === "success") {
                    message.success("แก้ไขสำเร็จ");
                    refetch();
                    if (refetchTo !== undefined) {
                      refetchTo();
                    }
                  } else {
                    message.error("แก้ไขไม่สำเร็จ");               
                  }
                },
                onError: () => {
                  message.error("แก้ไขไม่สำเร็จ");
                },
              });
            }}
            style={{ 
              width: "100%", 
             // color: "#A0A0A0"
             }}
          >
          {data?.is_active ? "ปิดการขาย" : "เปิดการขาย"}
          </Button>
          <Button
            onClick={() => {
              navigate(`/manage-product/edit/${data?.id}`);
            }}
            style={{
              width: "100%",
              marginLeft: 10,
              marginRight: 10,
             // color: "#A0A0A0",
            }}
          >
            แก้ไข
          </Button>
          <Dropdown menu={{ items }} placement="bottomRight">
            <Button
              className="product-btn"
              style={{ 
                width: 50, 
               // color: "#A0A0A0",
               }}
            >
              ...
            </Button>
          </Dropdown>
        </DateWrapper>
      </CardWrapper>
    </Col>
  );
};

export default ProductCard;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 0px;
`;

const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ImageWrapper = styled.div`
  width: 80px;
  height: 80px;
  background-color: #efefef;
  margin-right: 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  height: 80px;
  width: auto;
  border-radius: 0px;
  cursor: pointer;
`;

const CardPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  border-radius: 0px;
  cursor: pointer;
  padding-top: 0px;
`;

const Divider = styled.div`
  border-bottom: 0.5px solid #e8e8e8;
  margin: 10px 0px 10px 0px;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 20px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
  margin-bottom: 0px;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
`;

const RowStockAndOrder = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 0px 0px 5px 0px;
`;

const ColumnStock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;
`;
